const type = 'SET_DISPUTE_ANSWER';

const setDisputeAnswer = (data) => ({
  data,
  type,
});

export { type };
export default setDisputeAnswer;
